module.exports = __webpack_public_path__ + "media/images/lb/101-3e1b5d53dd37bda2ea172e832d35f7cb.svg";